const NEW_TAG = 'NEW';
export default NEW_TAG;
